var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/add-note") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24 0 24 24 0 24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/add-note",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.135,10.861 L13.654,10.861 C13.426,10.861 13.24,11.046 13.24,11.274 L13.24,13.755 C13.24,14.44 12.685,14.995 12,14.995 C11.315,14.995 10.76,14.44 10.76,13.755 L10.76,11.274 C10.76,11.046 10.574,10.861 10.346,10.861 L7.865,10.861 C7.18,10.861 6.625,10.305 6.625,9.62 C6.625,8.935 7.18,8.38 7.865,8.38 L10.346,8.38 C10.574,8.38 10.76,8.195 10.76,7.966 L10.76,5.486 C10.76,4.8 11.315,4.245 12,4.245 C12.685,4.245 13.24,4.8 13.24,5.486 L13.24,7.966 C13.24,8.195 13.426,8.38 13.654,8.38 L16.135,8.38 C16.82,8.38 17.375,8.935 17.375,9.62 C17.375,10.305 16.82,10.861 16.135,10.861 M21.6,0 L2.4,0 C1.074,0 0,1.074 0,2.4 L0,24 L4.8,19.2 L21.6,19.2 C22.926,19.2 24,18.126 24,16.799 L24,2.4 C24,1.074 22.926,0 21.6,0",
    id: "Fill-1",
    fill: "#666666",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNote);
export default __webpack_public_path__ + "static/media/addNote.87ada70fd642435bbe02715ffcd717f6.svg";
export { ForwardRef as ReactComponent };